import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissingContentIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 87,
	height: 86,
	viewBox: "0 0 87 86",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 43.5,
			cy: 42.8634,
			r: 42.8634,
			fill: "url(#paint0_linear_10263_43514)"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ii_10263_43514)",
			children: /* @__PURE__ */ _jsx("ellipse", {
				cx: 43.5,
				cy: 42.8657,
				rx: 27.6036,
				ry: 26.7671,
				fill: "url(#paint1_linear_10263_43514)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M50.5001 50.8643V49.8643C50.5001 47.6551 48.7092 45.8643 46.5001 45.8643H40.5001C38.2909 45.8643 36.5001 47.6551 36.5001 49.8643V50.8643",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 43.5001,
				cy: 38.8643,
				r: 4,
				stroke: "#2B313A",
				strokeWidth: 1.5
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ii_10263_43514",
				x: 15.8964,
				y: 16.0986,
				width: 55.2072,
				height: 56.7422,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.20797 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.20797 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0627451 0 0 0 0 0.0588235 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_10263_43514"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3.20797 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.62392 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0666667 0 0 0 0 0.0627451 0 0 0 0 0.0588235 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_10263_43514",
						result: "effect2_innerShadow_10263_43514"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10263_43514",
				x1: 27.7438,
				y1: 2.77476,
				x2: 62.3915,
				y2: 85.7749,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#E0E0E0",
					stopOpacity: .2
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6B6B6B",
					stopOpacity: .2
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10263_43514",
				x1: 65.6555,
				y1: 14.6898,
				x2: 25.8064,
				y2: 72.2707,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D2D0CE" }), /* @__PURE__ */ _jsx("stop", {
					offset: .804744,
					stopColor: "#D7D5D3"
				})]
			})
		] })
	]
});
export default SvgMissingContentIcon;
